(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('cart-form');
    if (!form) return;
    form.querySelectorAll('[data-quantity-wrapper]').forEach(function(wrapper) {
      const input = wrapper.querySelector('[data-quantity-input]');
      const minus = wrapper.querySelector('[data-quantity-minus]');
      const plus = wrapper.querySelector('[data-quantity-plus]');
      if (!input || !minus || !plus) return;
      minus.addEventListener('click', function() {
        const val = parseInt(input.value, 10) || 0;
        if (val > 0) input.value = val - 1;
      });
      plus.addEventListener('click', function() {
        const val = parseInt(input.value, 10) || 0;
        input.value = val + 1;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    const form = document.getElementById('collection-sort-form');
    const select = document.getElementById('collection-sort');
    if (form && select) {
      select.addEventListener('change', function() {
        form.submit();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"]) return;
  try {
    
  (function() {
    var section = document.querySelector('.contact-section');
    if (!section) return;
    var select = section.querySelector('#contact-form-subject');
    var hidden = section.querySelector('#contact-form-subject-value');
    var customWrap = section.querySelector('#contact-form-subject-custom-wrap');
    var customInput = section.querySelector('#contact-form-subject-custom');
    if (!select || !hidden || !customWrap || !customInput) return;

    function syncSubject() {
      var val = select.value;
      if (val === 'other') {
        customWrap.hidden = false;
        customInput.required = true;
        hidden.value = customInput.value.trim() || '';
      } else {
        customWrap.hidden = true;
        customInput.required = false;
        customInput.value = '';
        hidden.value = val;
      }
    }

    select.addEventListener('change', syncSubject);
    customInput.addEventListener('input', function() {
      if (select.value === 'other') hidden.value = this.value.trim();
    });

    var form = section.querySelector('form.contact-form');
    if (form) {
      form.addEventListener('submit', function() {
        if (select.value === 'other') hidden.value = customInput.value.trim();
      });
    }

    syncSubject();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const slider = document.querySelector('[data-testimonials-slider]');
    if (!slider) return;

    const track = slider.querySelector('[data-testimonials-track]');
    const cards = slider.querySelectorAll('[data-testimonial-card]');
    const prevBtn = slider.querySelector('[data-testimonials-prev]');
    const nextBtn = slider.querySelector('[data-testimonials-next]');

    if (!track || cards.length === 0) return;

    function getVisibleCount() {
      const w = slider.offsetWidth;
      if (w >= 1024) return 3;
      if (w >= 640) return 2;
      return 1;
    }

    function getMaxPage() {
      const visible = getVisibleCount();
      return Math.max(0, Math.ceil(cards.length / visible) - 1);
    }

    let currentPage = 0;

    function updateTransform() {
      const visible = getVisibleCount();
      const percent = currentPage * (100 / visible);
      track.style.transform = 'translateX(-' + percent + '%)';
      if (prevBtn) prevBtn.disabled = currentPage <= 0;
      if (nextBtn) nextBtn.disabled = currentPage >= getMaxPage();
    }

    function goPrev() {
      if (currentPage > 0) {
        currentPage--;
        updateTransform();
      }
    }

    function goNext() {
      const maxPage = getMaxPage();
      if (currentPage < maxPage) {
        currentPage++;
        updateTransform();
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', goPrev);
    if (nextBtn) nextBtn.addEventListener('click', goNext);

    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        const maxPage = getMaxPage();
        if (currentPage > maxPage) currentPage = maxPage;
        updateTransform();
      }, 100);
    });

    updateTransform();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    // Auto-select USD as default currency on first visit
    if (!sessionStorage.getItem('currency_set')) {
      var forms = document.querySelectorAll('#header-currency-form, #header-mobile-currency-form');
      forms.forEach(function(form) {
        var select = form && form.querySelector('select[name="country_code"]');
        if (select) {
          var usdOption = select.querySelector('option[value="US"]');
          if (usdOption && !usdOption.selected) {
            select.value = 'US';
            form.submit();
          }
        }
      });
      sessionStorage.setItem('currency_set', 'true');
    }

    document.querySelectorAll('#header-currency-form, #header-mobile-currency-form').forEach(function(form) {
      var select = form && form.querySelector('select[name="country_code"]');
      if (select) select.addEventListener('change', function() { form.submit(); });
    });

    var hamburger = document.querySelector('[data-header-hamburger]');
    var mobileNav = document.querySelector('[data-header-mobile-nav]');
    var mobileLinks = document.querySelectorAll('[data-header-mobile-link]');

    if (!hamburger || !mobileNav) return;

    function openMenu() {
      hamburger.setAttribute('aria-expanded', 'true');
      mobileNav.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      hamburger.setAttribute('aria-expanded', 'false');
      mobileNav.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function toggleMenu() {
      var isOpen = hamburger.getAttribute('aria-expanded') === 'true';
      if (isOpen) closeMenu();
      else openMenu();
    }

    hamburger.addEventListener('click', toggleMenu);

    mobileLinks.forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && hamburger.getAttribute('aria-expanded') === 'true') {
        closeMenu();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const slideshow = document.querySelector('[data-hero-slides]');
    if (!slideshow) return;

    const slides = slideshow.querySelectorAll('[data-hero-slide]');
    const dots = document.querySelectorAll('[data-hero-dot]');
    const prevBtn = document.querySelector('[data-hero-prev]');
    const nextBtn = document.querySelector('[data-hero-next]');
    const autoplaySpeed = parseInt(slideshow.closest('.hero')?.dataset?.autoplaySpeed || '5', 10) * 1000;
    const autoplay = slideshow.closest('.hero')?.dataset?.autoplay === 'true';

    if (slides.length <= 1) return;

    let currentIndex = 0;
    let autoplayTimer;

    function goToSlide(index) {
      currentIndex = (index + slides.length) % slides.length;

      slides.forEach((slide, i) => {
        const isActive = i === currentIndex;
        slide.classList.toggle('hero__slide--active', isActive);
        slide.style.opacity = isActive ? '1' : '0';
        slide.style.visibility = isActive ? 'visible' : 'hidden';
        slide.style.pointerEvents = isActive ? 'auto' : 'none';
        const content = slide.querySelector('.hero__content');
        if (content) content.style.display = isActive ? 'grid' : 'none';
      });

      dots.forEach((dot, i) => {
        dot.classList.toggle('hero__dot--active', i === currentIndex);
        dot.setAttribute('aria-selected', i === currentIndex);
      });
    }

    function nextSlide() {
      goToSlide(currentIndex + 1);
      resetAutoplay();
    }

    function prevSlide() {
      goToSlide(currentIndex - 1);
      resetAutoplay();
    }

    function resetAutoplay() {
      if (autoplay && autoplaySpeed > 0) {
        clearInterval(autoplayTimer);
        autoplayTimer = setInterval(nextSlide, autoplaySpeed);
      }
    }

    prevBtn?.addEventListener('click', prevSlide);
    nextBtn?.addEventListener('click', nextSlide);

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        goToSlide(index);
        resetAutoplay();
      });
    });

    if (autoplay && autoplaySpeed > 0) {
      autoplayTimer = setInterval(nextSlide, autoplaySpeed);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"]) return;
  try {
    
  (function() {
    const section = document.querySelector('.product-tabs');
    if (!section) return;

    const tabs = section.querySelectorAll('[data-product-tab]');
    const panels = section.querySelectorAll('[data-product-panel]');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        const id = tab.getAttribute('data-product-tab');
        tabs.forEach(function(t) {
          t.classList.remove('product-tabs__tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('product-tabs__tab--active');
        tab.setAttribute('aria-selected', 'true');

        panels.forEach(function(panel) {
          const panelId = panel.getAttribute('data-product-panel');
          if (panelId === id) {
            panel.classList.add('product-tabs__panel--active');
            panel.removeAttribute('hidden');
          } else {
            panel.classList.remove('product-tabs__panel--active');
            panel.setAttribute('hidden', '');
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    const section = document.querySelector('.product-detail');
    if (!section) return;

    const form = section.querySelector('#product-form');
    const thumbnails = section.querySelectorAll('[data-product-thumb]');
    const mainImage = section.querySelector('#product-main-image');
    const variantSelect = section.querySelector('[data-variant-select]');
    const variantInput = form && form.querySelector('input[name="id"]');
    const variantBtns = section.querySelectorAll('[data-variant-id]');
    const qtyInput = section.querySelector('.product-detail__qty-input');
    const qtyMinus = section.querySelector('[data-qty-minus]');
    const qtyPlus = section.querySelector('[data-qty-plus]');

    thumbnails.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var fullUrl = thumb.getAttribute('data-full-url');
        var img = thumb.querySelector('img');
        if (mainImage) {
          if (fullUrl) {
            mainImage.src = fullUrl;
          } else if (img) {
            mainImage.src = img.src;
          }
          if (img) mainImage.alt = img.alt || '';
        }
        thumbnails.forEach(function(t) { t.classList.remove('product-detail__thumb--active'); });
        thumb.classList.add('product-detail__thumb--active');
      });
    });

    if (variantBtns.length && variantSelect) {
      variantBtns.forEach(function(btn) {
        if (btn.tagName === 'BUTTON') {
          btn.addEventListener('click', function() {
            const id = btn.getAttribute('data-variant-id');
            variantSelect.value = id;
            if (variantInput) variantInput.value = id;
            variantBtns.forEach(function(b) { b.classList.remove('product-detail__variant-btn--active'); });
            btn.classList.add('product-detail__variant-btn--active');
          });
        }
      });
    }

    if (qtyInput && qtyMinus) {
      qtyMinus.addEventListener('click', function() {
        const v = parseInt(qtyInput.value, 10) || 1;
        if (v > 1) qtyInput.value = v - 1;
      });
    }
    if (qtyInput && qtyPlus) {
      qtyPlus.addEventListener('click', function() {
        const v = parseInt(qtyInput.value, 10) || 0;
        if (v < 99) qtyInput.value = v + 1;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
